// import React from 'react';
// import '../styles/Header.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';

// function Header() {
//     return (
//         <div>
//             <div className="contact-bar">
//                 <div className="contact-info">
//                     <span className="contact-item">
//                         <i className="fas fa-phone"></i>
//                         <a
//                             href="tel:+918368327503"
//                             style={{ textDecoration: 'none', color: 'inherit' }}
//                         >
//                             +91-8368327503, +91-9319563429
//                         </a>
//                     </span>

//                     <span className="contact-item">
//                         <i className="fas fa-envelope"></i>
//                         <a
//                             href="mailto:connect@empowerweb.in"
//                             style={{ textDecoration: 'none', color: 'inherit' }}
//                         >
//                         connect[at]empowerweb[dot]in
//                         </a>
//                     </span>
//                 </div>

//             </div>
//         </div>
//     );
// }

// export default Header;

import React from "react";
import "../styles/Header.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function Header() {
  return (
    <div className="top-header">
      {/* LEFT SIDE : CONTACT */}
      <div className="contact-left">
        <span className="contact-item">
          <i className="fas fa-phone"></i>
          <a href="tel:+919315020291">+91 9315020291</a>
        </span>
|
        <span className="contact-item">
          <i className="fas fa-envelope"></i>
          <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
        </span>
      </div>
      <div className="alert-right">
        <div className="marquee">
          Important Alert: Grow Your Business with Digital Marketing, Web
          Development & AI Automation Solutions
        </div>
      </div>
    </div>
  );
}

export default Header;
